import React, { useCallback, useEffect, useState } from 'react';
import Main from './layouts/main';
import { General } from './libraries/db-types';
import { myEnv } from './libraries/_env';
import { initJsStore } from './services/storage-base-service';
import DB from './services/storage-service';
import './theme/style.scss';


// DB init
initJsStore();

function App() {

  const [loaded, setLoaded] = useState(false);
  const [appData, setAppData] = useState<General[]>([{
    title: '',
    link: '',
    base_blog_url: '',
    base_site_url: '',
    description: '',
    generator: '',
    language: 'ja',
    pubDate: new Date(),
    wxr_version: 0,
  }]);

  const updateData = useCallback(() => {
    // サイト基本情報の取得
    DB.getGeneral().then(ret => {
      if (ret.length) {
        setAppData(ret);
      } else {
        alert(`${myEnv.strings.noSiteData}\n${myEnv.strings.noDataFound}`);
        setAppData([{
          title: '',
          link: '',
          base_blog_url: '',
          base_site_url: '',
          description: '',
          generator: '',
          language: 'ja',
          pubDate: new Date(),
          wxr_version: 0,
        }])
      }
    }).catch(err => {
      alert(`${myEnv.strings.dbConnectionError}\n${err}`);
    }).then(() => {
      setTimeout(() => {
        setLoaded(true);
      }, 1500)
    });
  }, [])

  useEffect(() => {
    // console.log(appData);
    // サイト基本情報の取得
    updateData();
  }, [updateData]);

  return (
    <>
    <div className="App">
      <Main appData={appData[0]} onUpdateRequest={updateData}></Main>
    </div>
    {!loaded && <div className="splash">
        {/* <Icon name='bio' onClick={() => {console.log('Now Loading')}}></Icon> */}
        {/* <div aria-busy></div> */}
      </div>}
    </>
  );
}

export default App;
